
// 加签私钥
const PRIVATE_KEY = 'MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCW9miJyCEMcBjqhPYkbL3cqetbEUN6WMn4DRJu4fB7RgWFxq99jAem8G4vSylAU5g+w32d8IGRlYpObnBjGnUnKU9Bjz2NGRMUT9nUFO5Equ3W4vpRH0yHoPJLd3NOPvBCrmNxJgkXCIkp1YREu5+74K86M9ZPcNVPsohJAkoDw3lWFIFERedE4w1YmOVQCG7NEq1cq9RK5kQanZH7yWE6LThICqV+HxQ/s2sKLlec5oT/vvN/lhDzPvocToBc2D4nsi/u6vttsynoD3BzMFrUVyz+YXh13yqhC9uQLNZho8sGzfAWw7qlW/ptoceAt5e/0cn6Wp5gqbeMdiOBCNQ9AgMBAAECggEAZPMYCvMCbp/TeZg6RTdWa2ZRVY+g0QLo5HBRYEbEmprDfKbVmZ33TAJBnGylhDeiem4d5Wz8KA+Y8kPV8d+yceKk9lFENsOKx61yG+l3QAIRk/4qp+7HLXdKL38MY0mhPuYA55wovfdeSdRXY+MXuPpSExiw+mSYsHfRvQjD1+lrJ3yA2BZ2AN/kAj/FIgdP7kNZAhILRkewXQ5TCbVqOHUwNiwbaDc0GaeCwUiyYNYLm+eQQ5qMxuMyl4FYCC6HX9D9OPULLJdGIl3WMCBO5UwrwSriN2L6O1jU63imwWeay0pYkG6eeOEprnxXPE1VEb2xB00zitrg8Ux6UXyoXQKBgQDQxt5gNW8MF3vIIECC3IXrj83EYcldSxHqZp3qmHuE0rRTzMIjYFBMddntHGRcrM34aVgNAngQeUZEYDt+2fCA10k3CyFPIbTk700hZ4XtKiJxPlEtyrqMgESzUUlF8i2HaMfJsz1xN8/Yckc24IgdWdTntVNQ5ajHsDXORD3upwKBgQC5G9P2VJWAe0mgOoCEycjv3mcpnOJgDWe4PfgGQJYCOOVwigBx+AiYzorhsJL8O0c8q+E8cbXCdKHzTg6ymLs4Bc6lzUR/6/gtraH8J/bo7sWqGHPDTEn8yUjts4Po4sH5Ojv8O4n8KR4KyyH8k8BpwvkNoWi+hHJfYLVxof7GewKBgE89S6WkYjNqrlZ0t0dzv3h6qhSBMNYx6ejXbdReb3MoLb0ol/6pTZDXohD2l7j89Wf1Q7AcYcmO3faRt8MboMal72nu1YOdPXUuxk2JZzFurofgqRsCOO+et3R/w5nCozkjscCCQS25iy+RoCnZ6o+JSt9u2OJ5aCfyX1mcWQ09AoGABpTAsm9LaWf4tCOgUhhCdpS3ojkbq0KOv3Qkj0RYkPeo4JlnbqXc2GHvehqm/yS0YanSti1swt8WqunJh/v6HAHI2Qg1OT8Qcb9MlQRuuNVUXbnE09qwfrZBS4IoXG1DbDLv0wXi3/4uPT//k1VFb/0okZ19ddiLoGx1xvZ1cmUCgYEAkftGjsmfdEyTNuWrgF6DW6jGd4E+wYfRHROZWXuHdtTWY4wlMpN4pnq5MygmvEee6D1BIqjL5Bh+opEpxnrK73SYJEOqQIJ3ngwNvSNYZZ4o7XUwWbCt1IDw6q6sUiGsLXsHWjeEwY+1M7BmWESK+w0Od8TppKUAneKXec/1QWQ='
// 商户名称
const BIS_NAME = '樱花蛋糕'
const PWD_MAX_LEN = '16'
// token请求头中的名称
const HEADER_TOKEN_NAME = 'accessToken'
// token存储key
const TOKEN_KEY = 'yhToken'
// 登录信息存储key
const LOGIN_INFO_KEY = 'yhLoginInfo'
// 数据源记号存储key
const DS_STORE_CODE_KEY = 'hyksStoreCode'
// 管理员的roleId
const MANAGER_ROLEID = 2
// 管理员的storeId
const MANAGER_STORE_ID = 0
// 可以选择数据源的roleId
const CHANGE_DS_ROLEID = [1,2]
// 首页底部导航栏选中颜色
const FOOTER_ACTIVED_COLOR = '#e42e42'
// 默认数据源编码
const DEFAULT_STORE_CODE = '0'
// 首页底部菜单项目
const HOME_FOOTER_MENU = [
    {
        push: '/',
        name: '首页',
        icon: 'el-icon-house',
        iconSelect: 'el-icon-house',
        
    }
]
// 首页功能菜单列表
const HOME_MENU_LIST = [
    // 第一页
    [
        // 配件导出
        {
            push: 'partExpendWare',
            name: '配件导出',
            imgSrc: 'inventory.png'
        },        
        // 费用支出
        {
            push: 'addDailyExpend',
            name: '费用支出',
            imgSrc: 'spending.png'
        },
        // 支出导出
        {
            push: 'dailyExpendExport',
            name: '支出导出',
            imgSrc: 'export.png'
        },        
        // 分类管理
        {
            push: 'typeManage',
            name: '分类管理',
            imgSrc: 'cards.png',
            managerOnly: true
        },
        // 门店管理
        {
            push: 'storeManage',
            name: '门店管理',
            imgSrc: 'restaurant.png',
            managerOnly: true
        },
        // 用户管理
        {
            push: 'userManage',
            name: '用户管理',
            imgSrc: 'employee.png',
            managerOnly: true
        },
        // 数据统计
        // {
        //     push: 'realhome',
        //     name: '数据统计',
        //     imgSrc: 'analytics.png'
        // },        
    ]
]

export default {
    PRIVATE_KEY,
    BIS_NAME,
    PWD_MAX_LEN,
    TOKEN_KEY,
    LOGIN_INFO_KEY,
    MANAGER_ROLEID,
    HOME_FOOTER_MENU,
    FOOTER_ACTIVED_COLOR,
    HOME_MENU_LIST,
    DEFAULT_STORE_CODE,
    DS_STORE_CODE_KEY,
    CHANGE_DS_ROLEID,
    HEADER_TOKEN_NAME,
    MANAGER_STORE_ID
}


// WEBPACK FOOTER //
// ./src/common/constant/constant.js